<template>
    <div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-sm">
            <img class="mx-auto h-20 w-20" src="/img/logo.png"
                alt="Your Company" />
            <h2 class="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">Registro de empleado</h2>
        </div>

        <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form id="registrationForm" class="space-y-6" @submit.prevent="submitForm">
                <div>
                    <label for="name" class="block text-sm font-medium leading-6 text-gray-900">Ingrese el nombre del Empleado</label>
                    <div class="mt-2">
                        <input id="name" name="name" type="name" autocomplete="name" required=""
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>
                <div>
                    <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Ingrese el Email del Empleado</label>
                    <div class="mt-2">
                        <input id="email" name="email" type="email" autocomplete="email" required=""
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>
                <div>
                    <label for="email2" class="block text-sm font-medium leading-6 text-gray-900">Confirme el Email</label>
                    <div class="mt-2">
                        <input id="email2" name="email2" type="email2" autocomplete="email2" required=""
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>
                <div>
                    <label for="password" class="block text-sm font-medium leading-6 text-gray-900">Ingrese una contraseña temporal</label>
                    <div class="mt-2">
                        <input id="password" name="password" type="password" autocomplete="password" required=""
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>
                <div>
                    <label for="password2" class="block text-sm font-medium leading-6 text-gray-900">Confirme la constraseña</label>
                    <div class="mt-2">
                        <input id="password2" name="password2" type="password2" autocomplete="password2" required=""
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>
                <div>
                    <button type="submit"
                        class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Registrar Empleado</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        methods: {
            async submitForm() {
                event.preventDefault();
                
                const name = document.getElementById('name').value;
                const email = document.getElementById('email').value;
                const email2 = document.getElementById('email2').value;
                const password = document.getElementById('password').value;
                const password2 = document.getElementById('password2').value;

                // Verifica que los correos electrónicos coincidan
                if (email !== email2) {
                    alert('Los correos electrónicos no coinciden');
                    return;
                }
                if (password !== password2) {
                    alert('Las constraseñas no coinciden');
                    return;
                }

                // Construye el objeto de datos a enviar
                const data = {
                    name,
                    email,
                    password
                };

                try {
                    // Realiza la solicitud POST a la API utilizando Axios
                    const response = await axios.post('http://127.0.0.1:8000/api/users', data);

                    // Verifica si la solicitud fue exitosa
                    if (response.status === 200) {
                        alert('Empleado registrado exitosamente');
                        // Aquí puedes redirigir a otra página si lo deseas
                    } else {
                        // Si la solicitud no fue exitosa, muestra el mensaje de error
                        alert('Error al registrar empleado');
                    }
                } catch (error) {
                    // Si hay un error de red u otro error, muestra un mensaje genérico
                    console.error('Error al enviar solicitud:', error);
                    alert('Se produjo un error al enviar la solicitud');
                }
            }
        }
    }
</script>
